import type { Feature } from './api';

/**
 * The features the editor should render.
 *
 * Existing features keep their position and pick up a draft when one exists.
 * Features created in this edit session are not part of the base collection, so
 * they must be appended explicitly; otherwise a new point stays invisible and
 * cannot be selected or named until the proposal is saved and reloaded.
 */
export function mergeEditedFeatures(
  base: Feature[],
  drafts: Record<string, Feature>,
  deletedIds: string[],
): Feature[] {
  const deleted = new Set(deletedIds);
  const baseIds = new Set(base.map((feature) => feature.id));
  const existing = base
    .filter((feature) => !deleted.has(feature.id))
    .map((feature) => drafts[feature.id] ?? feature);
  const added = Object.values(drafts).filter((feature) => !baseIds.has(feature.id));
  return [...existing, ...added];
}
